export default __webpack_public_path__ + "static/media/CCRB_database_raw.f5e31baa.csv";